import { InviteEmailConflict } from './invite-email-conflict.enum'
import { InviteEmailConflictError } from './InviteEmailConflictError'

export type InviteConflictMessages = {
  alreadyMember: string
  alreadyInvited: string
}

export const mapInviteConflictErrorToMessage = (error: unknown, messages: InviteConflictMessages): string | null => {
  if (!(error instanceof InviteEmailConflictError)) {
    return null
  }

  return error.conflict === InviteEmailConflict.ALREADY_MEMBER ? messages.alreadyMember : messages.alreadyInvited
}
